import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { readCookie } from "common/FunctionUtils";

// Get user from localStorage
let user = JSON.parse(localStorage.getItem("user"));

if (user) {
  if (new Date().getTime() > new Date(user.expireIn).getTime()) {
    user = null;
    localStorage.removeItem("user");
  }
}

const initialState = {
  message: "",
  isError: false,
  freelancers: [],
  isSuccess: false,
  isLoading: false,
  user: user?.userData || null,
  bankDetails: [],
  timeSheetData: {},
  getAllTimeSheetData: [],
  userData: {},
};

export const registerWithEmailAndPassword = createAsyncThunk(
  "auth/registerWithEmailAndPassword",
  async (user, thunkAPI) => {
    try {
      const tduid = localStorage.getItem("tduid");
      const requestBody = { ...user, tduid };
      const res = await axios.post(`/signup/add?lang=${user?.language}`, requestBody);
      if (!(res.data.statusCode === 200 || res.data.statusCode === 201)) {
        return thunkAPI.rejectWithValue(res.data.message);
      }
      if (document.cookie) {
        const isCookiesAccepted = readCookie("accept");
        if (isCookiesAccepted) {
          window.ttq.track("CompleteRegistration");
        }
      }
      return res.data;
    } catch (error) {
      const message =
        (error?.response &&
          error?.response?.data &&
          error?.response?.data?.message) ||
        error?.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const loginWithEmailAndPassword = createAsyncThunk(
  "auth/loginWithEmailAndPassword",
  async (user, thunkAPI) => {
    try {
      const res = await axios.post("/auth/login", {
        ...user,
        role: 2,
      });
      if (!(res.data.statusCode === 200 || res.data.statusCode === 201)) {
        return thunkAPI.rejectWithValue(res.data.message);
      }
      if (res.data.response) {
        localStorage.setItem("user", JSON.stringify(res.data.response));
      }
      return res.data.response;
    } catch (error) {
      const message =
        (error?.response &&
          error?.response?.data &&
          error?.response?.data?.message) ||
        error?.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const loginWithBankId = createAsyncThunk(
  "auth/loginWithBankId",
  async (id, thunkAPI) => {
    try {
      const res = await axios.post(`/auth/${id}`);
      if (!(res.data.statusCode === 200 || res.data.statusCode === 201)) {
        return thunkAPI.rejectWithValue(res.data.message);
      }
      if (res.data.response) {
        localStorage.setItem("user", JSON.stringify(res.data.response));
      }
      return res.data.response.userData;
    } catch (error) {
      const message =
        (error?.response &&
          error?.response?.data &&
          error?.response?.data?.message) ||
        error?.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const resetPasswordForEmail = createAsyncThunk(
  "auth/resetPasswordForEmail",
  async (email, thunkAPI) => {
    try {
      const language = localStorage.getItem("i18nextLng");
      const res = await axios.get(
        `/signup/forgot-password?email=${email}&language=${language}`
      );
      if (!(res.data.statusCode === 200 || res.data.statusCode === 201)) {
        return thunkAPI.rejectWithValue(res.data.message);
      }
      return res.data.response;
    } catch (error) {
      const message =
        (error?.response &&
          error?.response?.data &&
          error?.response?.data?.message) ||
        error?.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAllFreelancers = createAsyncThunk(
  "auth/getAllFreelancers",
  async () => {
    try {
      const allFreelancers = await axios.get("/freelancer");
      return allFreelancers.data.response || [];
    } catch (error) {
      return [];
    }
  }
);

export const updatePassword = createAsyncThunk(
  "auth/updatePassword",
  async (data, thunkAPI) => {
    try {
      const res = await axios.post("/signup/update-password", {
        newPassword: data.password,
        token: data.token,
      });
      if (!(res.data.statusCode === 200 || res.data.statusCode === 201)) {
        return thunkAPI.rejectWithValue(res.data.message);
      }
      return res.data.response;
    } catch (error) {
      const message =
        (error?.response &&
          error?.response?.data &&
          error?.response?.data?.message) ||
        error?.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getBankDetails = createAsyncThunk(
  "auth/getBankDetails",
  async (thunkAPI) => {
    try {
      const res = await axios.get(`/Settings`);
      if (!(res.data.statusCode === 200 || res.data.statusCode === 201)) {
        return thunkAPI.rejectWithValue(res.data.message);
      }
      return res.data.response;
    } catch (error) {
      const message =
        (error?.response &&
          error?.response?.data &&
          error?.response?.data?.message) ||
        error?.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getTimeSheetData = createAsyncThunk(
  "auth/getTimeSheetData",
  (data) => {
    return data;
  }
);

export const getAllTimeSheet = createAsyncThunk(
  "auth/getAllTimeSheet",
  async (data, thunkAPI) => {
    try {
      const res = await axios.get(`/TimeSheet`);
      if (!(res.data.statusCode === 200 || res.data.statusCode === 201)) {
        return thunkAPI.rejectWithValue(res.data.message);
      }
      return res.data.response;
    } catch (error) {
      const message =
        (error?.response &&
          error?.response?.data &&
          error?.response?.data?.message) ||
        error?.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getInvoiceData = createAsyncThunk('auth/getEdit', (data) => data);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logOut: (state) => {
      state.user = null;
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.bankDetails = [];
      localStorage.removeItem("user");
    },
      resetGetInvoiceData: (state) => {
      state.getInvoiceData = null;
    },
    reset: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
    },
    updateUser: (state, action) => {
      state.user = action.payload;
    },
  },
  extraReducers: {
    [registerWithEmailAndPassword.pending]: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
    },
    [registerWithEmailAndPassword.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.userData = action.payload;
    },
    [registerWithEmailAndPassword.rejected]: (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload;
    },
    [loginWithEmailAndPassword.pending]: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
    },
    [loginWithEmailAndPassword.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.user = action.payload.userData;
    },
    [loginWithEmailAndPassword.rejected]: (state, action) => {
      state.isLoading = false;
      state.isError = (action?.payload === "account_deactivated" || action?.payload === "inactive_account") ? false : true;
      state.message = action.payload;
      state.user = null;
    },
    // [loginWithBankId.pending]: (state) => {
    //   state.isLoading = true;
    //   state.isSuccess = false;
    //   state.isError = false;
    //   state.message = "";
    // },
    // [loginWithBankId.fulfilled]: (state, action) => {
    //   state.isLoading = false;
    //   state.isSuccess = true;
    //   state.user = action.payload;
    // },
    // [loginWithBankId.rejected]: (state, action) => {
    //   state.isLoading = false;
    //   state.isError = (action?.payload === "account_deactivated" || action?.payload === "inactive_account") ? false : true;
    //   state.message = action.payload;
    //   state.user = null;
    // },
    [resetPasswordForEmail.pending]: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
    },
    [resetPasswordForEmail.fulfilled]: (state) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [resetPasswordForEmail.rejected]: (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload;
    },
    [updatePassword.pending]: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
    },
    [updatePassword.fulfilled]: (state) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [updatePassword.rejected]: (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload;
    },
    [getAllFreelancers.pending]: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
    },
    [getAllFreelancers.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.freelancers = action.payload;
    },
    [getAllFreelancers.rejected]: (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload;
    },
    [getBankDetails.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
    },
    [getBankDetails.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.bankDetails = action.payload;
    },
    [getBankDetails.rejected]: (state, action) => {
      state.isLoading = false;
      state.isError = (action?.payload === "account_deactivated" || action?.payload === "inactive_account") ? false : true;
      state.message = action.payload;
    },
    [getTimeSheetData.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
    },
    [getTimeSheetData.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.timeSheetData = action.payload;
    },
    [getTimeSheetData.rejected]: (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload;
    },
    [getAllTimeSheet.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
    },
    [getAllTimeSheet.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.getAllTimeSheetData = action.payload;
    },
    [getAllTimeSheet.rejected]: (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload;
    },
      [getInvoiceData.pending]: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
    },
      [getInvoiceData.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.getInvoiceData = action.payload;
    },
    [getInvoiceData.rejected]: (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload;
    },
  },
});

export const { logOut, reset, updateUser, resetGetInvoiceData } = authSlice.actions;

export default authSlice.reducer;
